import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import MepAvatar from "./MepAvatar";
import {Box, Card, CardHeader, Grid, MenuItem, Typography} from "@material-ui/core";
import { Mep } from "../../service/data";
import { ViewChannelButton } from "../button";
import {FiltersContext, searchHighlightRegExp} from "../../service/filters"
import { safeHtml } from "../../service/tools/safeHtml";

interface MepCardProps {
    className?: string;
    record: Mep;
}

const MepCard: FunctionComponent<MepCardProps> = (props: MepCardProps) => {
    const { className, record } = props;
    // The short code, not the full group name: "ECR, Poland" rather than "European Conservatives
    // and Reformists Group, Poland", which wrapped over three lines on a card this size.
    const { id, country, firstName, lastName, politicalGroup: { party, eparty }} = record;
    const groupLabel = eparty || party;
    const [filters,setFilters] = React.useContext(FiltersContext);

    const regexp = React.useMemo(() => searchHighlightRegExp(filters.channels.search || ''), [filters.channels.search]);


    const highlightContent = (text:string):string => {
        if(regexp === null) return text;
        return text.replace(regexp, (item:string,i:number) => {
            return '<mark>'+item+'</mark>';
         })
        
    };


    return (
        <Grid item xs={12} sm={6} md={6} lg={4} className="gridItem mepGridItem">
            <Link to={`/contributors/${id}`} className="dblock">
                <Card className={className}>
                    <CardHeader
                        action={
                            <ViewChannelButton />
                        }
                        avatar={
                            <MepAvatar record={record} />
                        }
                        subheader={
                            <Box className="preWrap">
                                <Typography variant="subtitle2" display="inline" component="p">
                                    <strong>
                                        {groupLabel}
                                        {groupLabel? ", " :''}
                                    </strong>
                                </Typography>
                                <Typography variant="subtitle2" display="inline" component="p">
                                    {country}
                                </Typography>
                            </Box>
                        }
                        title={
                            <Typography variant="h2" component="p">
                                <div  dangerouslySetInnerHTML={{ __html: safeHtml(highlightContent(`${firstName} ${lastName}`)) }} />
                                                 
                            </Typography>
                        }
                    />
                </Card>
            </Link>
        </Grid>
    );
};

export default MepCard;
